import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { getTargetsUpdatePayload } from '@albacross/frontend-utils'

import { campaignTargetFromServer, getCampaignTargetsQuery } from 'models/campaign-targets-model'
import { get, post, put } from 'utils/http'

export const useCampaignTargets = (id: any, meta: any) =>
  useQuery({
    queryKey: ['campaignTargets', id, meta],
    queryFn: async () => {
      const { count, targets } = await get<{ count: number; targets: any[] }>(`/management/campaigns/${id}/targets`, {
        query: getCampaignTargetsQuery(meta),
      })
      return { count, items: (targets || []).map(campaignTargetFromServer) }
    },
    enabled: !!id,
  })

// `updates` is the Immutable running/paused selection from the redux campaign-targets slice; refetch the list on success.
export const useUpdateTargets = (id: any) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (updates: any) => put(`/management/campaigns/${id}/targets`, getTargetsUpdatePayload(updates)),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['campaignTargets', id] }),
  })
}

// `selected` is the Immutable List of matched company ids to import.
export const useImportTargets = (id: any) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (selected: any) =>
      post(`/management/campaigns/${id}/targets/import`, selected?.toJS ? selected.toJS() : selected),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['campaignTargets', id] }),
  })
}
